import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import {
  LegalAcceptanceDetail,
  LegalAcceptanceQuery,
  LegalDocumentDetail,
  LegalDocumentQuery,
  LegalDocumentSaveRequest,
  LegalDocumentVersionDetail,
  LegalDocumentVersionSaveRequest,
  PagedResult,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class LegalClientService {
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);
  private readonly http = inject(HttpClient);

  queryDocuments(query: LegalDocumentQuery): Observable<PagedResult<LegalDocumentDetail>> {
    return this.http.post<PagedResult<LegalDocumentDetail>>(OperationsApiRoutes.legalDocumentsQuery, query, {
      context: this.quietContext,
    });
  }

  getDocument(id: string): Observable<LegalDocumentDetail> {
    return this.http.get<LegalDocumentDetail>(OperationsApiRoutes.legalDocumentById(id));
  }

  createDocument(request: LegalDocumentSaveRequest): Observable<LegalDocumentDetail> {
    return this.http.post<LegalDocumentDetail>(OperationsApiRoutes.legalDocuments, request);
  }

  updateDocument(id: string, request: LegalDocumentSaveRequest): Observable<LegalDocumentDetail> {
    return this.http.put<LegalDocumentDetail>(OperationsApiRoutes.legalDocumentById(id), request);
  }

  createVersion(documentId: string, request: LegalDocumentVersionSaveRequest): Observable<LegalDocumentVersionDetail> {
    return this.http.post<LegalDocumentVersionDetail>(OperationsApiRoutes.legalDocumentVersions(documentId), request);
  }

  publishVersion(versionId: string): Observable<LegalDocumentVersionDetail> {
    return this.http.post<LegalDocumentVersionDetail>(OperationsApiRoutes.legalVersionPublish(versionId), {});
  }

  archiveVersion(versionId: string): Observable<LegalDocumentVersionDetail> {
    return this.http.post<LegalDocumentVersionDetail>(OperationsApiRoutes.legalVersionArchive(versionId), {});
  }

  queryAcceptances(query: LegalAcceptanceQuery): Observable<PagedResult<LegalAcceptanceDetail>> {
    return this.http.post<PagedResult<LegalAcceptanceDetail>>(OperationsApiRoutes.legalAcceptancesQuery, query, {
      context: this.quietContext,
    });
  }
}
